import { LayoutCanvasDecorator } from '../ui/layout/layout-canvas.decorator';
import { environment } from '../../../environments/environment';

export class WarehouseCanvasDecorator extends LayoutCanvasDecorator {
  constructor(
    protected readonly canvas: HTMLCanvasElement,
    protected readonly enableMouseHandler = false,
  ) {
    super(canvas, enableMouseHandler, environment.appConfig.watson.layoutDebugInfos);
  }
}
